import { MESSAGE_TYPES } from '../const/analytics';
import MULTI_PAYMENT_FLOW_TABS from '../const/multiPaymentFlowTabs';
import { isRevolvingCreditProduct } from './productTypeHelpers';
const getDCHMessageType = (isDigitalCollectionsEnabled, accountSummary, multiPaymentFlowCurrentTab) => {
    const isRevolvingCredit = isRevolvingCreditProduct(accountSummary.product.type);
    const { customerAssistancePlan, pastDue, settlementEnrolled } = accountSummary.billing;
    if (!isDigitalCollectionsEnabled || !isRevolvingCredit) {
        return null;
    }
    if (customerAssistancePlan) {
        return MESSAGE_TYPES.DCH.CAP;
    }
    if (settlementEnrolled) {
        if (multiPaymentFlowCurrentTab === MULTI_PAYMENT_FLOW_TABS.MULTI) {
            return MESSAGE_TYPES.DCH.SETTLEMENT_MULTI;
        }
        return MESSAGE_TYPES.DCH.SETTLEMENT;
    }
    if (pastDue) {
        return MESSAGE_TYPES.DCH.DELINQUENT;
    }
    return null;
};
export default getDCHMessageType;
